import React, { Component } from 'react'
import { Table, DatePicker, Button, message } from 'antd'
import moment from 'moment'
import { getLastMonth } from '../../../../util/index'
import { toHourMinuteSecond, clickDownload } from '../../../../util/index'
import { attendanceMonthRecord } from '../../../../api/employee'
const { RangePicker } = DatePicker

export default class monthTable extends Component {
  state = {
    isloading: true,
    pickerValue: [
      moment(getLastMonth().firstDay, 'YYYY-MM'),
      moment(getLastMonth().firstDay, 'YYYY-MM'),
    ],
    hackValue: null,
    dates: [],
    list: [],
  }

  componentDidMount() {
    this.getDatas()
  }

  getDatas = async () => {
    const sTime = moment(this.state.pickerValue[0])
    const eTime = moment(this.state.pickerValue[1])
    sTime.date(1)
    sTime.startOf('day')
    eTime.add(1, 'month').startOf('month')
    const { status, detail, data } = await attendanceMonthRecord({
      startTimestamp: sTime.unix(),
      endTimestamp: eTime.unix(),
    })
    this.setState({
      isloading: false,
    })
    if (status != 1) {
      message.error(detail)
      return
    }
    const dataAry = [].concat(data)
    if (dataAry && dataAry.length > 0) {
      const newData = dataAry.map((item) => {
        const { employee } = item
        const { hour, minute, second } = toHourMinuteSecond(item.extraDuration)
        return {
          employeeId: employee.id, // 员工id
          name: employee.name, // 员工名称
          beLate: item.beLate, //迟到次数
          leaveEarly: item.leaveEarly, //早退次数
          locateException: item.locateException, //地址异常次数
          absenteeism: item.absenteeism, //缺勤次数
          leave: item.leave, //请假次数
          extraDuration: `${hour}.${minute}`, //加班时长
        }
      })
      this.setState({
        list: newData,
      })
    } else {
      this.setState({
        list: [],
      })
    }
  }

  onChange = (value, dateString) => {
    if (!value) {
      return
    }
    this.setState({
      pickerValue: value,
    })
  }

  onOpenChange = (open) => {
    if (open) {
      this.setState({
        dates: [],
        hackValue: [],
      })
    } else {
      this.setState({
        hackValue: undefined,
      })
    }
  }

  onCalendarChange = (val) => {
    this.setState({
      dates: val,
    })
  }

  disabledDate = (current) => {
    if (!this.state.dates || this.state.dates.length === 0) {
      return false || current >= moment()
    }
    // 控制选择范围6个月内
    const tooLate =
      this.state.dates[0] && current.diff(this.state.dates[0], 'months') > 4
    const tooEarly =
      this.state.dates[1] && this.state.dates[1].diff(current, 'months') > 4
    return tooLate || tooEarly || current >= moment()
  }

  onSearchEvent = () => {
    if (this.state.isloading) {
      return
    }
    this.setState({ isloading: true }, this.getDatas)
  }

  render() {
    const { isloading, list, hackValue, pickerValue } = this.state
    const dateString = pickerValue
      ? `${pickerValue[0].format('YYYY-MM-DD')}-${pickerValue[1].format(
          'YYYY-MM-DD'
        )}`
      : moment().format('YYYY-MM-DD')
    const columns = [
      {
        title: '员工',
        dataIndex: 'name',
      },
      {
        title: '迟到',
        dataIndex: 'beLate',
      },
      {
        title: '早退',
        dataIndex: 'leaveEarly',
      },
      {
        title: '地址异常',
        dataIndex: 'locateException',
      },
      {
        title: '休假',
        dataIndex: 'leave',
      },
      {
        title: '缺勤',
        dataIndex: 'absenteeism',
      },
      {
        title: '加班',
        dataIndex: 'extraDuration',
      },
    ]
    return (
      <div>
        <div className="com-table-select-top-view">
          <RangePicker
            disabledDate={this.disabledDate}
            format="YYYY-MM"
            picker="month"
            placeholder={['开始时间', '结束时间']}
            value={hackValue || pickerValue}
            onChange={this.onChange}
            onCalendarChange={this.onCalendarChange}
            onOpenChange={this.onOpenChange}
          />
          <Button
            type="primary"
            className="button-flex-left"
            onClick={this.onSearchEvent}
          >
            查询
          </Button>
          <Button type="default" className="button-flex-left">
            <a
              id="test"
              href={clickDownload(columns, list || [])}
              download={`考勤记录月度统计-${dateString}.csv`}
            >
              导出
            </a>
          </Button>
        </div>
        <Table
          rowKey="employeeId"
          loading={isloading}
          bordered
          size="small"
          columns={columns}
          dataSource={list}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubAttendanceRecord/component/monthTable/monthTable.js